import React from "react";
import VendorManagementSection from "../../LoanDetailsPage/VendorManagementSection";

const FacilitySuppliersTab: React.FC = () => {
  return (
    <div className="cx-max-w-[960px] cx-mx-auto cx-px-4 sm:cx-px-6">
      <div className="cx-py-4">
        <VendorManagementSection />
      </div>
    </div>
  );
};

export default FacilitySuppliersTab;
